import getDeviceInfo from '@/lib/base/getDeviceInfo';
import NAVIGATION from '@/constant/navigation.js';
const deviceDetails = getDeviceInfo();
const {viewMode} = deviceDetails;
const isMobile = viewMode === 'phone';

export default [
  {
    path: '/student-management',
    name: 'studentManagement',
    component: () => import('@/views/StudentManagement/index.vue'),
    meta: {
      hasNavigation: !isMobile,
      requireAuth: true,
      fromUpperTransitionType: 'slide',
      toUpperTransitionType: 'slide',
      activeTab: NAVIGATION.TABS.LEARNING,
    },
  },
  {
    path: '/student-management/pvp',
    name: 'studentPvp',
    component: () => import('@/views/StudentManagement/StudentPvp.vue'),
    meta: {
      hasNavigation: true,
      requireAuth: true,
      requireDesktop: true,
      activeTab: NAVIGATION.TABS.LEARNING,
    },
  },
  {
    path: '/student-management/statistics',
    name: 'statistics',
    component: () => import('@/views/StudentManagement/StatisticsDetail.vue'),
    meta: {
      hasNavigation: !isMobile,
      requireAuth: true,
      fromUpperTransitionType: 'slide',
      toUpperTransitionType: 'slide',
      activeTab: NAVIGATION.TABS.LEARNING,
    },
  },
];
